import axios from 'axios';
import config from '../config';

import { getBaseUrlFromConfig } from '../utils/url_helpers';
// import { getJwt } from '../utils/store';

export function log(logMessage, logData) {
  // console.log(`writing a ${logMessage} log`);
  return axios.post(
    `${getBaseUrlFromConfig(config.biztechApi)}/default/log/${logMessage}`,
    logData,
    {
      headers: {
        'content-type': 'application/json',
      },
    }
  );
}
